export const NAME = 'foldTypes';